// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/@angular/material/prebuilt-themes/deeppurple-amber.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-select {
  position: relative;
  width: 100%;
  text-align: center;
}
.date-select .hidden-date-input {
  opacity: 0;
  left: -50px;
  width: 100px;
  pointer-events: none;
  position: absolute;
}
.date-select .date-input {
  position: relative;
  display: inline-block;
  width: 152px;
  text-align: center;
  overflow: visible;
  cursor: pointer;
}
.date-select .ngx-dates-picker-input {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  width: 100% !important;
  box-sizing: border-box;
  cursor: pointer;
}
.date-select .date {
  font-size: 1em;
  vertical-align: top;
}
.date-select .date-button {
  font-size: 32px;
  cursor: pointer;
}
@media (hover: hover) {
  .date-select .date-button:hover {
    color: var(--motes-gold);
  }
}
.date-select .date-button:not(:active) {
  animation-name: clickAnim;
  animation-duration: 1.2s;
}
@keyframes clickAnim {
  1% {
    color: var(--motes-gold);
  }
}
.date-select .ngx-dates-picker-calendar-container {
  color: rgb(43, 43, 43);
  left: -50% !important;
  z-index: 2;
  width: auto;
  box-sizing: border-box;
  padding-right: 30px;
  width: 320px;
}
.date-select .time-row {
  display: inline-block;
}
.date-select .time-input {
  border-radius: 3px 0px 0px 3px;
  box-sizing: border-box;
  vertical-align: bottom;
}
.date-select .time-input input {
  background-color: rgba(255, 255, 255, 0);
  border: none;
  padding: 0px;
  font-size: 1em;
  color: inherit;
  font-family: "Century Gothic", Gothic, sans-serif;
  box-sizing: border-box;
}
.date-select .calendar-icon, .date-select .clock-icon {
  padding-right: 4px;
}

.mat-calendar-body-selected {
  background-color: var(--motes-highlight-color);
}

.mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),
.cdk-keyboard-focused .mat-calendar-body-active > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),
.cdk-program-focused .mat-calendar-body-active > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical) {
  background-color: var(--motes-highlight-color);
}

input[type=time]::-webkit-clear-button {
  display: none;
}

[type=time]::-webkit-inner-spin-button {
  display: none;
}

[type=time]::-webkit-calendar-picker-indicator {
  opacity: 0;
  display: none;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/time-picker/time-picker.component.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAEI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAAR;AAGI;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AADR;AAII;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AAFR;AAKI;EACI,cAAA;EACA,mBAAA;AAHR;AAMI;EACI,eAAA;EACA,eAAA;AAJR;AAQI;EACI;IACI,wBAAA;EANV;AACF;AAUI;EACI,yBAAA;EACA,wBAAA;AARR;AAWK;EACI;IAAK,wBAAA;EARZ;AACF;AAUI;EACI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AARR;AAWI;EACI,qBAAA;AATR;AAYI;EACI,8BAAA;EACA,sBAAA;EACA,sBAAA;AAVR;AAaQ;EACI,wCAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,iDAAA;EACA,sBAAA;AAXZ;AAeI;EACI,kBAAA;AAbR;;AAmBA;EACI,8CAAA;AAhBJ;;AAmBA;;;EAGI,8CAAA;AAhBJ;;AAmBA;EACI,aAAA;AAhBJ;;AAmBA;EACI,aAAA;AAhBJ;;AAmBA;EACI,UAAA;EACA,aAAA;AAhBJ","sourcesContent":["@import '@angular/material/prebuilt-themes/deeppurple-amber.css';\n\n.date-select {\n    position: relative;\n    width: 100%;\n    text-align: center;\n    \n    .hidden-date-input {\n        opacity: 0;\n        left: -50px;\n        width: 100px;\n        pointer-events: none;\n        position: absolute;\n    }\n\n    .date-input {\n        position: relative;\n        display: inline-block;\n        width: 152px;\n        text-align: center;\n        overflow: visible;\n        cursor: pointer;\n    }\n    \n    .ngx-dates-picker-input {\n        position: absolute;\n        opacity: 0;\n        left: 0;\n        top: 0;\n        width: 100% !important;\n        box-sizing: border-box;\n        cursor:pointer;\n    }\n    \n    .date {\n        font-size: 1em;\n        vertical-align: top;\n    }\n    \n    .date-button {\n        font-size: 32px;\n        cursor: pointer;\n    }\n    \n    // Only show hover on desktop\n    @media(hover: hover) {\n        .date-button:hover {\n            color: var(--motes-gold);\n        }\n    }\n    \n    // Enylate hover / click css\n    .date-button:not(:active) {\n        animation-name: clickAnim;\n        animation-duration: 1.2s;\n     }\n\n     @keyframes clickAnim {\n         1% { color: var(--motes-gold) }\n     }\n    \n    .ngx-dates-picker-calendar-container {\n        color:rgb(43, 43, 43);\n        left: -50%!important;\n        z-index: 2;\n        width: auto;\n        box-sizing: border-box;\n        padding-right: 30px;\n        width: 320px;\n    }\n    \n    .time-row {\n        display: inline-block;\n    }\n    \n    .time-input {\n        border-radius: 3px 0px 0px 3px;\n        box-sizing: border-box;\n        vertical-align: bottom;\n        // background-color: rgb(255, 255, 255);\n\n        input {\n            background-color: rgba(255, 255, 255, 0);\n            border: none;\n            padding: 0px;\n            font-size: 1em;\n            color: inherit;\n            font-family: \"Century Gothic\", Gothic, sans-serif;\n            box-sizing: border-box;\n        }\n    }\n\n    .calendar-icon, .clock-icon {\n        padding-right: 4px;\n    }\n\n    \n}\n\n.mat-calendar-body-selected {\n    background-color: var(--motes-highlight-color);\n}\n\n.mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), \n.cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), \n.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical) {\n    background-color: var(--motes-highlight-color);\n}\n\ninput[type=\"time\"]::-webkit-clear-button {\n    display: none;\n}\n\n[type=\"time\"]::-webkit-inner-spin-button {\n    display: none;\n}\n\n[type=\"time\"]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
